//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Grid } from '@mui/material';
import styled from '@emotion/styled';
import { convertStylesToStyled } from '@/_utils/utils';

const AssetTotalStatus = ({ value = 0, label = 'Total' }) => {
  return (
    <StyledWrapperGrid  item>
      <strong>{value}</strong>
      <span>{label}</span>
    </StyledWrapperGrid >
  )
}

export default AssetTotalStatus;

const StyledWrapperGrid  = styled(Grid)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70px;
  width: 70px;
  opacity: 0.66;
  text-transform: uppercase;
  font-size: 0.8rem;
  line-height: 1.8rem;
  margin-top: ${props => props.theme.spacing(.25)};
  font-weight: ${props => props.theme.typography.fontWeightMedium};

  & strong {
    display: block;
    font-size: 1.25rem;
    line-height: 1rem;

  }

  ${({ theme }) => convertStylesToStyled(theme.customOverrides?.AssetTotalStatus)}
`;